<template>
  <div>
    <el-upload
      ref="uploadRef"
      class="upload"
      action="http://8.136.151.147:8087/oss/upload"
      :data="getObject"
      :on-success="handleUploadSuccess"
      :before-upload="beforeAvatarUpload"
      v-show="false"
    >
    </el-upload>
    <div class="imgaeList" >
      <div class="list" v-if="proPicList">
        <img :src="proPicList" />
        <span class="mask">
          <img
            src="../assets/delete.png"
            class="delete"
            @click="handleRemove()"
          >	
        </span>      
      </div>
      <div class="list2" @click="handleUpload" v-else>
        <i class="el-icon-plus avatar-uploader-icon" ></i>
      </div>
      <span>{{tip}}</span>
    </div>
  </div>
</template>

<script>
import { getCommonToken } from "../utils/publish"
export default {
  name: 'uploadImage',
  props: {
    value: String, 
    tip:{
      type:String
    },
  },
  data(){
    return{
      accessToken:undefined,
      proPicList:""
    }
  },
  computed: {
    getObject() {
      let token = this.accessToken
      return { token }
    }
  },
  methods:{
    // 上传图片
    handleUpload(file) {
      this.$nextTick(() => {
        this.$refs.uploadRef.$el.querySelector('.el-upload__input').click();
      });
    },
    // 移除图片
    handleRemove(imageUrl, index) {
      this.proPicList = ""
    },
    // 校验
    beforeAvatarUpload(file){
      // console.log('file',file);
      let index = file.name.lastIndexOf(".");
      let extension = file.name.substr(index + 1);
      let extensionList = [
          "png",
          "PNG",
          "jpg",
          "JPG",
          "jpeg",
          "JPEG",
          "webp",
          "WEBP",
      ];
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message({
          message: "单张照片不可超出10M",
          type: "warning",
          center: true,
        });
        return false;
      } else if (extensionList.indexOf(extension) < 0) {
        this.$message({
          message: "当前文件格式不支持",
          type: "error",
          center: true,
        });
        return false;
      } else {
        return true
      }
    },
    // 上传成功
    handleUploadSuccess(response,file){
      // console.log("123",response)
      if(response.code == 500 ){
        this.$message({
          message: response.msg,
          type: "error",
          center: true,
        });
      }else if(response.data){
        // console.log('???',this.proPicList);
        this.proPicList = response.data.path
        this.$emit("input",this.proPicList)
      }
    },
  },
  created(){
    getCommonToken().then(response => {
      if(response.data.code == 200){
        this.accessToken = response.data.data
      }else{
        this.$message.error("获取token失败")
      }
      // console.log('response',response);
    })
  }
}
</script>

<style scoped lang="less">
.normal() {
  display: flex;
  align-items: center;
}
.fontdemo(@size,@family,@weight,@color){
  font-size:@size;
  font-family:@family;
  font-weight:@weight;
  color:@color
}
.imgaeList{
  span{
    text-align: center;
    font-size: 14px;
    color:rgb(12, 58, 191)
  }
}
.list{
  width: 100px;
  height: 100px;
  border-radius: 6px;
  img{
    width: 100%;
    height: 100px ;
    border-radius: 6px;
  }
  position: relative;
  .mask {
    position: absolute;
    left: 0;
    top: 0;
    justify-content: center;
    align-items: center;
    opacity: 0;
    font-size: 20px;
    border-radius: 6px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity .3s;
    width: 100%;
    height: 100px;
    border-radius: 6px;
    display: flex;
    cursor: pointer;
    .delete{
      width: 30px;
      height: 30px;
    }
  }
}
.list:hover .mask {
  opacity: 1;
}
.list2{
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 100px;
  height: 100px;
  border-radius: 6px;
  // margin-bottom: 30px;
  &:hover{
    border-color: #409EFF;
  }
  .avatar-uploader-icon{
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
}
</style>